import { render, staticRenderFns } from "./yearppmview.vue?vue&type=template&id=278839aa&scoped=true&"
import script from "./yearppmview.vue?vue&type=script&lang=js&"
export * from "./yearppmview.vue?vue&type=script&lang=js&"
import style0 from "./yearppmview.vue?vue&type=style&index=0&id=278839aa&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278839aa",
  null
  
)

export default component.exports